module.exports = require('./helpers/bundle-url').getBundleURL('01RMl') + "BBD.ad0b802e.png";